import cx from 'classnames';
import {useSelector} from 'react-redux';
import {MessageListener} from '~/CreateFabricInvitation/routes/EventGifting/components/MessageListener';
import {NavButtons} from '~/CreateFabricInvitation/routes/EventGifting/components/NavButtons';
import {selectEventStatus} from '~/common/fabric/reducers/eviteEvent/selectors';
import {Header} from './components/Header/Header';
import {OtherGiftOptions} from './components/OtherGiftOptions/OtherGiftOptions';
import {Registries} from './components/Registries/Registries';

type EventGiftingProps = {
  inPreviewStep?: boolean;
};

export const EventGifting = ({inPreviewStep = false}: EventGiftingProps) => {
  const eventStatus = useSelector(selectEventStatus);

  return (
    <div
      className={cx('create-flow__options event-gifting', {
        'in-preview-step': inPreviewStep,
      })}
    >
      <MessageListener />

      <div className="create-flow__form-container">
        <div
          className={cx('create-flow__form-gifting', {
            'create-flow__form-gifting__preview-step': inPreviewStep,
          })}
        >
          <Header inPreviewStep={inPreviewStep} />

          <Registries inPreviewStep={inPreviewStep} />

          <OtherGiftOptions />
        </div>

        {!inPreviewStep && <NavButtons eventStatus={eventStatus} />}
      </div>
    </div>
  );
};
